import React, { Component } from "react";

import "./MoreOptions.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ColorHelper from "../../helper/ColorHelper";
import ChatRequest from "../../request/ChatRequest";
import { ButtonIcon, LabelInput } from "global-components-library";

let config = window["boot"].isMoreOption;

export default class MoreOptions extends Component {
  state = {
    showModal: false,
    email: "",
  };
  generateString = () => {
    let list = this.props.msgList;
    let msg = "";
    list.map((x) => {
      if (x.position === "left") {
        msg += `${this.props.agentName}: ${x.msg} \n`;
      } else {
        msg += `${this.props.userName.userName}: ${x.msg} \n`;
      }
    });
    return msg;
  };

  copyToClipboard = () => {
    let text = this.generateString();
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };

  downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([this.generateString()], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "conversation.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  onEmailChanged = (e) => {
    this.setState({ email: e.target.value });
  };

  onSendEmail = () => {
    ChatRequest.SendEmail(
      this.props.session,
      this.generateString(),
      this.state.email
    );
    this.setState({ showModal: false });
  };

  valdateEmail = (v) => {
    let validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return validRegex.test(v);
  };

  render() {
    const { moreOptions: moreOptionsLabels } = window["labels"];
    const {
      chatSize,
      isMoreOption: { isBtnSend },
      resize: { active = false, resizeHeight = null, resizeWidth = null } = {},
    } = window["boot"];
    
    return (
      <div className="moreOptions-container">
        <Header minimize={this.props.minimize}></Header>
        <div
          className={`moreOptions-main ${!active && chatSize}`}
          style={
            active
              ? {
                  height: "calc(100% - 2rem)",
                  width: resizeWidth,
                }
              : {}
          }
        >
          <div className="moreOptions-icon">
            <ButtonIcon
              icon={"arrow"}
              onClick={() => this.props.onMoreOptionsChange()}
            />
          </div>
          <div className="moreOptions-body">
            <div className="title">{moreOptionsLabels.scheduleContact}</div>
            <div
              className="subtitle"
              style={
                (active && resizeHeight < "25rem") ||
                (resizeHeight < "400px"
                  ? {
                      marginBottom: "0rem",
                    }
                  : {})
              }
            >
              {moreOptionsLabels.hours}
            </div>
            <div className="title">{moreOptionsLabels.contacNumber}</div>
            <div
              className="subtitle"
              style={
                (active && resizeHeight < "25rem") || resizeHeight < "400px"
                  ? {
                      marginBottom: "0rem",
                    }
                  : {}
              }
            >
              {moreOptionsLabels.contactNo}
            </div>
            <div className="title">{moreOptionsLabels.socialMedia}</div>
            <div className="title icons">
              <a href={window["boot"].twitterPage} target="_blank">
                <div className="twitter" />
              </a>
              <a href={window["boot"].facebookPage} target="_blank">
                <div className="facebook" />
              </a>
            </div>
          </div>
          {isBtnSend && (
            <div className="moreOptions-send">
              <div className="text">{moreOptionsLabels.lblMail}</div>
              <div
                className={`input ${
                  this.valdateEmail(this.state.email) && "active"
                }`}
              >
                <LabelInput
                  type="text"
                  value={this.state.email}
                  label={moreOptionsLabels.mailPlaceholder2}
                  placeholder={moreOptionsLabels.mailPlaceholder}
                  onChange={(e) => this.setState({ email: e })}
                  onEnter={this.state.email && this.onSendEmail}
                />
                <ButtonIcon
                  className={`input-button`}
                  icon={"send-mail"}
                  onClick={this.state.email && this.onSendEmail}
                  disabled={!this.valdateEmail(this.state.email)}
                />
              </div>
            </div>
          )}
        </div>
        <Footer></Footer>
      </div>
    );
  }
}
